import UserPageWrapper from './UserPageWrapper';

export default UserPageWrapper;
